{
  "accountDetails": "Kontodetails",
  "last12months": "Letzte 12 Monate (mit Transaktionen)",
  "last10years": "Letzte 10 Jahre",
  "stats": "Kernzahlen",
  "goToReports": "Zu den Reports",
  "synchronisingChanges": "Synchronisiere Änderungen...",
  "noConnectedAccount": "Bankkonto verlinken",
  "initialSaldo": "Deine Bank gab keine Details für eine Anfangstransaktion an. Falls nötig, teile sie in kleinere Transaktionen auf und passe die Daten an.",
  "help": "Link zu den Hilfeseiten dieses Screens.",
  "draft": "Deine Bank gibt keine Details für eine Transaktion an. Falls nötig, teile sie in kleinere Transaktionen auf und passe die Daten an.",
  "multipleSelected": "Mehrauswahl möglich",
  "errorFieldRequired": "Feld ist erforderlich",
  "errorOneRowRequired": "Mindestens ein Eintrag ist notwendig",
  "errorMustBePositive": "Muss positiv sein",
  "errorMustBeNumber": "Muss eine Zahl sein",
  "effectiveDate": "Gültig ab",
  "value": "Wert",
  "estimateType": "Art der Schätzung",
  "quote": "Auszahlung",
  "quoteInCurrency": "Auszahlung in {{currency}}",
  "create": "Neuer Eintrag",
  "quotesEmptyGeneric": "Keine Daten vorhanden",
  "quotesEmptyStocksManualOnly": "Hier werden nur manuell eingetragene Werte angezeigt. Bitte erfasse dazu einen Wert im Edit-Modus.",
  "quotesEmptyStocks": {
    "heading": "Kurswerte Aktien",
    "subheading": "Keine synchronisierten Marktwerte verfügbar",
    "intro": "Diese Ansicht zeigt aktuell nur manuell eingetragene Kurswerte deiner Bestände.",
    "featureTitle": "Nur manuelle Werte"
  },
  "buttons": {
    "duplicatesFound": "Wir haben Einträge identifiziert, die möglicherweise doppelt sind. Bitte überprüfe die folgenden Einträge und wenn gewünscht, unmarkiere die doppelten Einträge.",
    "editYourFile": "Du kannst jetzt die hochgeladene Datei bearbeiten. Klicke auf >Speichern<, um deine Änderungen zu speichern, oder auf >Abbrechen<, um zurückzugehen.",
    "fileTransformed": "Deine Datei wurde geändert, um die Änderungen von letztem Mal zu replizieren.",
    "fileTransformedUndo": "Rückgängig machen",
    "firstUpload": "Dies ist der erste Upload für dieses Konto. Bitte überprüfe die folgenden Einträge und wenn gewünscht, unmarkiere die doppelten Einträge.",
    "loading": "Datei wird verarbeitet...",
    "loadingTakesLong": "Der Vorgang kann mehr als 30 Sekunden dauern.",
    "columnMatcherHeader": "Spaltenzuordnung",
    "columnMatcherInfo": "Ziehe die Spaltenüberschriften an ihre richtigen Stellen in der oberen Zeile. Einige Überschriften wurden möglicherweise bereits für dich platziert. Bewege den Cursor über Tabelle-Ikonen in jeder Datei-Spalte um eine Vorschau dieser Spalte anzuzeigen. Nicht alle spalten der Datei müssen verwendet werden.",
    "columnName": "Spaltenname",
    "customColumnDescription": "Eine zusammengesetzte Spalte",
    "dragToScroll": "Ziehe um zu scrollen",
    "occursInRows": "Fehler in Zeilen",
    "headersInRow": {
      "label": "Überschriften in Zeile",
      "tooltip": "In welcher Zeile der Datei befinden sich die Überschriften?"
    },
    "decimalChar": {
      "label": "Dezimalzeichen:",
      "tooltip": "Verwendet deine Datei ein Komma oder einen Punkt als Dezimaltrennzeichen?"
    },
    "readOnly": {
      "tooltip": "Du kannst Transaktionen den Projekten hinzufügen, und sie werden hier angezeigt.",
      "label": "Diese Ansicht ist schreibgeschützt in Projekt-Modus."
    },
    "whatYouOwn": {
      "label": "Dein Eigentum",
      "tooltip": "Zeige die Liste aller Käufe und Verkäufe deiner Anlagen."
    },
    "whatIsItWorth": {
      "label": "Wert",
      "tooltip": "Zeige Wertänderungen deiner Anlagen in der Zeit an."
    },
    "payments": {
      "label": "Zahlungen",
      "tooltip": "Zeige geleistete und erhaltene Zahlungen an."
    },
    "presentValue": {
      "label": "Wert",
      "tooltip": "Zeige zu erwarteten monatlichen Zahlungen deines Produktes an (wie du sie von dem Institut erhalten hast, von dem du dieses Produkt gekauft hast)."
    },
    "sync": {
      "tooltip": "Transaktionen automatisch importieren."
    },
    "tableFilters": {
      "label": "Filter",
      "labelWithCount": "Filter ({{count}})",
      "tooltip": "Filtere die sichtbaren Zeilen nach Begriff, Betrag und Datum."
    },
    "import": {
      "label": "Import",
      "tooltip": "Transaktionen aus einer Datei importieren."
    },
    "table": {
      "label": "Tabelle",
      "tooltip": "Transaktionen anzeigen."
    },
    "grid": {
      "label": "Bearbeiten",
      "tooltip": "Angezeigten Daten in Spreadsheet editierbar machen."
    },
    "wizard": {
      "label": "Bearbeiten",
      "tooltip": "Bearbeite Bestände oder Werte über einen Assistenten."
    },
    "holdings": {
      "label": "Bestände",
      "tooltip": "Zeigt deine Bestände an."
    },
    "cashflow": {
      "label": "Zahlungen",
      "tooltip": "Zeigt alle Auszahlungen (Dividenden, Zinsen usw.) und alle Kosten, die mit diesem Konto verbunden sind."
    },
    "quotes": {
      "label": "Wert",
      "tooltip": "Zeigt Wertänderungen deiner Bestände an."
    },
    "settings": {
      "label": "Einstellungen",
      "tooltip": "Passe Kontoeinstellungen an."
    },
    "close": {
      "label": "Schliessen",
      "tooltip": "Änderungen verlassen und zum Dashboard zurückkehren."
    },
    "save": {
      "label": "Speichern",
      "tooltip": "Änderungen permanent speichern."
    },
    "saveAndClose": {
      "label": "Speichern und schliessen",
      "tooltip": "Änderungen permanent speichern und zum Import-Dialog zurückkehren."
    },
    "cancel": {
      "label": "Abbrechen",
      "tooltip": "Abbrechen und zu Tabelle-Sicht zurückkehren."
    },
    "undo": {
      "label": "Undo",
      "tooltip": "Letzte Änderung rückgängig machen."
    },
    "redo": {
      "label": "Redo",
      "tooltip": "Letzte Änderung wiederholen."
    },
    "uploadFiles": {
      "label": "Dateien hochladen",
      "tooltip": "Transaktionen aus lokalen Dateien importieren."
    },
    "cancelFileUpload": {
      "label": "Dateiupload abbrechen",
      "tooltip": "Schließt diesen Dialog, ohne etwas hochzuladen."
    },
    "resetColumns": {
      "label": "Spalten zurücksetzen",
      "tooltip": "Setzt alle Zuordnungen zurück."
    },
    "confirmAndContinue": {
      "label": "Bestätigen und fortfahren",
      "tooltip": "Fährt mit dem Import der Datei gemäß der unten angegebenen Zuordnungen fort."
    },
    "skipThisFile": {
      "label": "Diese Datei überspringen",
      "tooltip": "Überspringt diese Datei (ohne sie hochzuladen) und geht zur nächsten über."
    },
    "addAnotherOperation": {
      "label": "Weitere Operation zufügen",
      "tooltip": "Fügt eine weitere Operation zu Berechnung dieser Spalte hinzu."
    },
    "newColumn": {
      "label": "Spalte hinzufügen",
      "tooltip": "Fügt eine neue Spalte hinzu."
    },
    "editLoadedFile": {
      "label": "Datei editieren",
      "tooltip": "Passe die gerade hochgeladene Datei an."
    },
    "columnProperties": {
      "label": "Eigenschaften",
      "tooltip": ""
    },
    "columnActions": {
      "label": "Aktionen",
      "tooltip": ""
    }
  },
  "deleteThisColumn": {
    "label": "Diese Spalte löschen",
    "tooltip": "Löscht diese Spalte und alle zugeordneten Daten."
  },
  "historicalValueCalc": {
    "label": "Kaufpreis unbekannt?",
    "tooltip": "Wir berechnen gerne den geschätzten Wert am Kaufdatum. Wir benötigen dazu das Kaufdatum und die Attribute (Gewicht, Reinheit usw.)."
  },
  "previous": {
    "label": "< Vorherige",
    "tooltip": "Den vorherigen Eintrag öffnen."
  },
  "next": {
    "label": "Nächste >",
    "tooltip": "Den nächsten Eintrag öffnen."
  },
  "attributes": {
    "category": {
      "tooltip": "Kategorie, zu dieser dieses Konto gehört."
    },
    "bankName": {
      "tooltip": "Bank, die dieses Konto bereitstellt."
    },
    "brokerName": {
      "tooltip": "Broker, der dieses Depot bereitstellt."
    },
    "iban": {
      "tooltip": "IBAN-Nummer dieses Kontos."
    },
    "accountNo": {
      "tooltip": "Identifikator oder Nummer dieses Kontos.",
      "stub": "Depotnummer?"
    },
    "bic": {
      "tooltip": "BIC (Bank-Identifikationsnummer) dieser Bank."
    },
    "connectedCashAccount": {
      "tooltip": "Geldkonto, worauf die Kauf- / Verkaufsbetrag sowie Rendite-Zahlungen hierfür erfolgen.",
      "error": "Fehler: kein verbundenes Geldkonto liegt vor"
    },
    "streetAddress": {
      "tooltip": "Die Adresse der Immobilie"
    },
    "floorArea": {
      "tooltip": "Wohnfläche"
    },
    "numberOfRooms": {
      "tooltip": "Anzahl Zimmer"
    },
    "lotArea": {
      "tooltip": "Grundstückfläche"
    },
    "constructionYear": {
      "tooltip": "Baujahr"
    },
    "garage": {
      "tooltip": "Verfügt die Immobilie über eigene Garagen- oder Stellplatz?"
    },
    "currency": {
      "tooltip": "In welcher Währung soll die Wert der Immobilie angegeben werden?"
    },
    "multiple": "verlinkte Konten"
  },
  "columns": {
    "standardTooltip": "Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu ändern.",
    "emptyString": "",
    "readOnly": "(geschützt)",
    "category": "Kategorie",
    "date": "Datum",
    "Date (Day)": "Datum",
    "Date (Month)": "Datum",
    "Date (Year)": "Datum",
    "Income from capital": "Kapitaleinkommen",
    "accountName": "Kontoname",
    "displayName": "Name",
    "total": "Summe",
    "otherParty": "Andere Partei",
    "otherPartyAccount": "Andere Partei Kontonr.",
    "symbol": "Symbol",
    "description": "Bezeichnung",
    "amount": {
      "label": "Betrag",
      "tooltip": "Transaktionsbetrag in der Währung dieses Kontos. Bei vorhandenen Orginalwährung und Orginalbetrag kann der Betrag automatisch berechnet werden."
    },
    "quantity": {
      "label": "Anzahl",
      "tooltip": "Anzahl der gekauften (positive Zahl) oder verkauften (negative Zahl) Assets"
    },
    "label": {
      "label": "Tag",
      "tooltip": "Welche Art der Transaktion ist es? Diese Tags ermöglichen Berechnung deines Vermögens sowie diversen Indikatoren."
    },
    "principal": {
      "label": "Kapital",
      "tooltip": "Kapitalanteil der Kreditrate (d.h. der Betrag, der zur Tilgung des Kredits verwendet wird)."
    },
    "interest": {
      "label": "Zinsen",
      "tooltip": "Zinsanteil der Kreditrate (d.h. der Betrag, der als Zinsen an den Kreditgeber gezahlt wird)."
    },
    "iban": {
      "label": "IBAN",
      "tooltip": "IBAN-Nummer des Senders / Empfängers dieser Transaktion."
    },
    "transactionAmount": {
      "label": "Anzahl",
      "tooltip": "Anzahl der gehandelten Wertpapiere"
    },
    "transactionPrice": {
      "label": "Stückpreis",
      "tooltip": "Preis pro Stück des Wertpapiers, in der Währung der Transaktion"
    },
    "transactionCurrency": {
      "label": "Währung",
      "tooltip": "Währung, in der die Transaktion ursprünglich getätigt wurde"
    },
    "type": "Typ",
    "fxCurrency": {
      "label": "Originalwährung",
      "tooltip": "Währung, in der die Transaktion ursprünglich getätigt wurde (optional)"
    },
    "fxAmount": {
      "label": "Originalbetrag",
      "tooltip": "Transaktionsbetrag in der originalen Währung (optional)"
    },
    "fxAmountInterest": {
      "label": "Originalzinsen",
      "tooltip": "Transaktionszinsen in der originalen Währung (optional)"
    },
    "fxRate": {
      "label": "Wechselkurs",
      "tooltip": "Wechselkurs zwischen der originalen Währung und der Währung dieses Kontos (berechnet automatisch)"
    },
    "value": "Wert",
    "rebasedOriginalValue": "Wert\n(Transaktions-\nwärhung)",
    "rebasedValue": "Wert\n(Basis-\nwährung)",
    "rebasedAmount": {
      "label": "Anzahl\nnach\nSplits",
      "tooltip": "Anzahl der Wertpapiere der Transaktion, nachdem alle Splits seit dem Transaktionsdatum berücksichtigt worden sind."
    },
    "assetId": {
      "label": "Asset",
      "tooltip": "Für welches Asset ist dieser Preis?"
    },
    "assetName": {
      "label": "Name",
      "tooltip": "Wie möchtest du dieses Asset nennen?"
    },
    "assetMetal": {
      "label": "Metall",
      "tooltip": "Um welches Edelmetall handelt es sich? Wähle aus der Liste."
    },
    "assetPurity": {
      "label": "Reinheit",
      "tooltip": "Verschiedene Formen von Edelmetallvermögen haben unterschiedliche Reinheiten, z. B. .999 für Gold. Gib die Reinheit dieses Assets in Tausendstel an (999 oder 965)."
    },
    "assetAdditionalValue": {
      "label": "Zusatzwert",
      "tooltip": "Einige Münzen haben aufgrund ihrer Seltenheit oder künstlerischen Bedeutung einen zusätzlichen Wert. Gib den Zusatzwert deines Assets in Prozent an (dies wird zum reinen Metallwert hinzugefügt). Beispiel: wenn das Metall darin allein 100 wert ist und der zusätzliche Wert 20% beträgt, berechnen wir den Wert dieser Münze als 120. Steigt der Metallpreis, addieren wir weiterhin die 20% für diese Münze."
    },
    "assetWeight": {
      "label": "Gewicht",
      "tooltip": "Wieviel wiegt dieses Asset? Trage das Gewicht in Gramm ein."
    },
    "transactionValue": {
      "label": "Transaktionssumme",
      "tooltip": "Optional. Gekaufte/verkaufte Menge * Preis pro Einheit. Wenn du beide Werte eingibst, berechnen wir dies automatisch."
    },
    "transactionCurrencyValue": {
      "label": "Originelle Summe",
      "tooltip": "Optional. Gekaufte/verkaufte Menge * Preis pro Einheit in der ursprünglichen Transaktionswährung. Wenn du beide Werte eingibst, berechnen wir dies automatisch."
    },
    "rebasedOriginalPrice": {
      "label": "Preis\nnach\nSplits",
      "tooltip": "Wenn Wertpapiere einem Split unterworfen wurden, verringern sich ihre Stückpreise verhältnismäßig. Preise in dieser Spalte berücksichtigen diese Änderungen."
    },
    "pricePerSquareMetre": "Preis per m",
    "originalPricePerSquareMetre": "Preis (Original-\nwährung) per m",
    "transactionType": {
      "label": "Transaktionsart",
      "tooltip": "Kauf oder Verkauf der Immobilie."
    },
    "realEstateTransactionPrice": {
      "label": "Preis\n(Basiswährung)",
      "tooltip": "Der eigentliche Kaufs- oder Verkaufspreis, in der Basiswährung, Transaktionswährung kann automatisch berechnet werden. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu ändern."
    },
    "realEstateOriginalPrice": {
      "label": "Preis\n(Originalwährung)",
      "tooltip": "Der eigentliche Kaufs- oder Verkaufspreis, in der eigentlichen Transaktionswährung, Basiswährung kann automatisch berechnet werden.. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu ändern."
    },
    "source": {
      "label": "Quelle",
      "tooltip": "Kommt die Bewertung von dem Provider oder ist es manuell eingepflegt? Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu ändern."
    },
    "price": {
      "label": "Wert\n(Basis-\nwährung)",
      "tooltip": "Welchen Verkaufspreis (in Basiswährung) würde die Immobilie an dem Datum erzielen? Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu ändern.",
      "tooltipGrid": "Wenn Originalwährung und -preis vorhanden sind, wird dieses Feld automatisch berechnet."
    },
    "priceShort": {
      "label": "Preis"
    },
    "currency": "Originalwährung",
    "originalPrice": {
      "label": "Wert\n(Original-\nwährung)",
      "tooltip": "Welchen Verkaufspreis (in der Originalwährung) würde die Immobilie an dem Datum erzielen? Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu ändern.",
      "tooltipGrid": "Wenn leer, wird EUR eingesetzt."
    },
    "size": {
      "label": "Anzahl",
      "tooltip": "Anzahl aller noch nicht verkauften Wertpapiere dieser Transaktionen. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu ändern."
    },
    "split": {
      "label": "Split",
      "tooltip": "Verhältnis von alten zu neuen Aktien."
    },
    "openPositionSize": {
      "label": "Unverkaufte Anzahl",
      "tooltip": "Anzahl aller noch nicht verkauften Wertpapiere dieser Transaktionen. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu ändern."
    },
    "purchaseValue": {
      "label": "Kaufwert",
      "tooltip": "Wert beim Ankauf der Wertpapiere, in deiner Basiswährung. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu ändern."
    },
    "baselineValue": {
      "label": "Basiswert",
      "tooltip": "Wert an dem von dir festgelegten Basisdatum, in deiner Basiswährung. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu ändern."
    },
    "currentValue": {
      "label": "Aktueller Wert",
      "tooltip": "Aktueller Wert der Wertpapiere in deiner Basiswärhung. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu ändern."
    },
    "valueTransactionCurrency": {
      "label": "Wert\n(Transaktions-\nwärhung)",
      "tooltip": "Optional. Wert der Anlage in der Transaktionswährung. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu ändern."
    },
    "valueAccountCurrency": {
      "label": "Wert",
      "tooltip": "Optional. Wert der Anlage in der Kontowährung. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu ändern."
    },
    "valueBaseCurrency": {
      "label": "Wert\n(Basis\nwährung)",
      "tooltip": "Optional. Wert der Anlage in deiner Basisswährung. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu ändern."
    },
    "purchasePrice": {
      "label": "Kaufpreis",
      "tooltip": "Preis beim Ankauf der Wertpapiere, in deiner Basiswährung. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu ändern."
    },
    "baselinePrice": {
      "label": "Basispreis",
      "tooltip": "Preis an dem von dir festgelegten Basisdatum, in deiner Basiswährung. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu ändern."
    },
    "currentPrice": {
      "label": "Aktueller Preis",
      "tooltip": "Aktueller Preis und Wert der Wertpapiere in deiner Basiswärhung. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu ändern."
    },
    "purchaseCurrentValuePrice": {
      "label": "Wert / Preis",
      "tooltip": "Preis und Wert beim Ankauf der Wertpapiere sowie jetzt, in deiner Basiswährung. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu ändern."
    },
    "purchaseValuePrice": {
      "label": "Kaufwert / -preis",
      "tooltip": "Preis und Wert beim Ankauf der Wertpapiere, in deiner Basiswährung. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu ändern."
    },
    "baselineValuePrice": {
      "label": "Basiswert / -preis",
      "tooltip": "Preis und Wert an dem von dir festgelegten Basisdatum, in deiner Basiswährung. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu ändern."
    },
    "currentValuePrice": {
      "label": "Aktueller Wert / Preis",
      "tooltip": "Aktueller Preis und Wert der Wertpapiere in deiner Basiswärhung. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu ändern."
    },
    "dividends": {
      "label": "Dividenden / Gebühren",
      "tooltip": "Summe aller Dividenden und Gebühren seit dem Kauf der Wertpapiere + anteilig kontobezogenen Kosten. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu ändern."
    },
    "dividendsSincePurchase": {
      "label": "Dividenden / Gebühren seit Kauf ",
      "tooltip": "Summe aller Dividenden und Gebühren seit dem Kauf der Wertpapiere. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu ändern."
    },
    "roi": {
      "label": "ROI gesamt / ROI jährlich",
      "tooltip": "Aktueller Wert der Wertpapiere im Verhältnis zu dem Kaufwert (Return on Investment). Berücksichtigt Dividenden und Gebühren. Gesamt und als Durchschnitt pro Jahr. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu ändern."
    },
    "roiShort": {
      "label": "ROI gesamt / jährlich",
      "tooltip": "Aktueller Wert der Wertpapiere im Verhältnis zu dem Kaufwert (Return on Investment). Dividenden und Gebühren inklusiv. Gesamt und als Durchschnitt pro Jahr. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu ändern."
    },
    "roiOnly": {
      "label": "ROI",
      "tooltip": "Aktueller Wert der Wertpapiere im Verhältnis zu dem Kaufwert (Return on Investment). Dividenden und Gebühren inklusiv. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu ändern."
    },
    "payoutsSincePurchase": {
      "label": "Auszahlungen seit Kauf",
      "tooltip": "Summe aller Auszahlungen seit dem Kauf der Assets. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu ändern."
    },
    "feesSincePurchase": {
      "label": "Gebühren seit Kauf",
      "tooltip": "Summe aller Gebühren seit dem Kauf der Assets. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu ändern."
    },
    "costsSincePurchase": {
      "label": "Kosten seit Kauf",
      "tooltip": "Summe aller Kosten seit dem Kauf der Assets. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu ändern."
    },
    "roiAnnual": {
      "label": "Jährliches ROI",
      "tooltip": "Wie müsste der anfängliche Betrag der Investition verzinst sein, um den aktuellen Wert zu erreichen? Berücksichtigt Dividenden und Gebühren. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu ändern."
    },
    "keepFlag": {
      "label": "Behalten?",
      "tooltip": "Uncheck the rows that you want to remove from your import."
    },
    "payoutOnlyContributionsToDate": {
      "label": "Rente (nur Beiträge bis heute)",
      "tooltip": "Höhe der Rentenzahlungen, die du erhalten würdest, falls du heute die Beiträge einstellst."
    },
    "payoutOnlyContributionsToDateIndexed": {
      "label": "Rente (nur Beiträge bis heute,\nmit Wertentwicklung)",
      "tooltip": "Höhe der Rentenzahlungen, die du erhalten würdest, falls du heute die Beiträge einstellst, mit zukünftiger Wertentwicklung bereits angelegtes Kapitals."
    },
    "payoutAllPlannedContributions": {
      "label": "Rente (alle zukünftigen Beiträge)",
      "tooltip": "Höhe der Rentenzahlungen, die du erhalten würdest, falls du die Beiträge bis der Ende der Ansparphase zahlst."
    },
    "payoutAllPlannedContributionsIndexed": {
      "label": "Rente (alle zukünftigen Beiträge,\nmit Wertentwicklung)",
      "tooltip": "Höhe der Rentenzahlungen, die du erhalten würdest, falls du die Beiträge bis der Ende der Ansparphase zahlst, mit zukünftiger Wertentwicklung bereits angelegtes Kapitals."
    },
    "payoutLumpSumVerrentet": {
      "label": "Einmalzahlung in lebenslange Rente umwandeln",
      "tooltip": "Das angesparte Kapital wird in eine lebenslange Rente umgerechnet."
    },
    "note": {
      "label": "Note",
      "tooltip": "Valuation details"
    },
    "proceeds": {
      "label": "Einnahmen",
      "tooltip": "Einnahmen von diesem Wertobjekt"
    }
  },
  "stocks": {
    "allowedTransactionTypes": [
      "sale",
      "purchase",
      "split"
    ]
  },
  "deposits": {
    "labels": {
      "noLabel": {
        "long": "Ohne Tag",
        "short": "Ohne Tag"
      },
      "investment-fees": {
        "long": "Transaktionsgebühr",
        "short": "Gebühr"
      },
      "investment-costs": {
        "long": "Kontogebühr",
        "short": "Kontogebühr"
      },
      "investment-interest": {
        "long": "Zinsen",
        "short": "Zinsen"
      },
      "investment-dividend": {
        "long": "Dividende",
        "short": "Dividende"
      },
      "investment-transfer": {
        "long": "Transfer",
        "short": "Transfer"
      },
      "investment-rent": {
        "long": "Mieteinnahmen",
        "short": "Miete"
      },
      "investment-purchase": {
        "long": "Asset-Kauf",
        "short": "Asset-kauf"
      },
      "investment-sale": {
        "long": "Asset-Verkauf",
        "short": "Asset-Verkauf"
      },
      "investment-payout": {
        "long": "Kreditauszahlung",
        "short": "Kreditauszahlung"
      },
      "investment-loanRepayment": {
        "long": "Kreditrate",
        "short": "Kreditrate"
      },
      "investment-loanInterest": {
        "long": "Kreditrate (Zins)",
        "short": "Kredit (Zinsen)"
      },
      "investment-loanPrincipal": {
        "long": "Kreditrate (Kapital)",
        "short": "Kredit (Kapital)"
      },
      "investment-pension": {
        "long": "Rente (Auszahlung)",
        "short": "Rente"
      },
      "investment-contribution": {
        "long": "Rentenbeitrag",
        "short": "Beitrag"
      }
    },
    "markThisTransaction": "Diese Transaktion taggen",
    "noTransactions": "Keine mit diesem Konto verlinkten Transaktionen gefunden.",
    "noTransactionsWithin": "Keine ähnlichen, mit diesem Konto verlinkten Transaktionen gefunden, die innerhalb von 7 Tagen von dieser Transaktion stattfanden.",
    "noAccounts": "Keine verlinkten Konten gefunden.",
    "noAssets": "Keine Assets auf verlinkten Kontos gefunden.",
    "addTag": "Neuer Tag",
    "whichItem": "Auf welche(s) Konto / Transaktion bezieht sich die Transaktion?"
  },
  "pension": {
    "import": {
      "title": "Welches Produkt verwenden?",
      "prompt": "Du scheinst Daten von rvuebersicht.de zu importieren. In dieser Datei gibt es Daten für mehere Produkte. Bitte wähle das für dieses Konto richtige Produkt aus.",
      "ignore": "Ignorieren",
      "cancel": "Cancel",
      "baseCurrencyDialog": {
        "title": "Currency conversion",
        "prompt": "The currency of the imported data is different from the base currency of this account. How should we convert this currency? As it is difficult to predict the future exchange rate, we suggest to use today's.",
        "fxRate": "Exchange rate to use",
        "todayFxIs": "Today's exchange rate is",
        "apply": "Anwenden"
      }
    }
  },
  "contextMenu": {
    "addEmptyRowAbove": "Leere Zeile(n) oben einfügen",
    "addEmptyRowBelow": "Leere Zeile(n) unten einzufügen",
    "addEmptyColumnAbove": "Leere Spalte links einfügen",
    "addEmptyColumnBelow": "Leere Spalte rechts einfügen",
    "duplicateRow": "Zeile duplizieren",
    "duplicateColumn": "Spalte duplizieren",
    "deleteRow": "Zeile löschen",
    "deleteColumn": "Spalte löschen",
    "cut": "Ausschneiden",
    "copy": "Kopieren",
    "paste": "Einfügen",
    "download": "Alles exportieren",
    "downloadSelected": "Markierte Zeilen exportieren"
  },
  "splitMenu": {
    "split": "Aufteilen",
    "splitHeader": "Diese Transaktion in zwei oder mehr Transaktionen aufteilen",
    "splitInfo": "Denke daran, Transaktionsgebühren und Kauf-/Verkaufstransaktionen im verbundenen Einzahlungskonto aufzuteilen.",
    "splitExistingDetected": "Diese Transaktion wurde bereits aufgeteilt. Du kannst die Aufteilung bearbeiten oder die Aufteilung rückgängig machen.",
    "copyAsSimulated": "Als Simulation kopieren",
    "copyAsSimulatedInfo": "Erstelle eine simulierte Transaktion basierend auf dieser. Du kannst alle Parameter im nächsten Bildschirm anpassen.",
    "showInProject": "Mit Projekt verlinken",
    "showInProjectInfo": "Du kannst diese tatsächliche Transaktion in einem Projekt anzeigen.",
    "aiLabelLoanRepayment": "Zinsen und Tilgung automatisch erkennen",
    "aiLabelLoanRepaymentInfo": "Die KI ermittelt Tilgung und Zinsen für diese Transaktion (oder alle ausgewählten Transaktionen) und vergibt automatisch das Kreditraten-Label.",
    "aiLabelLoanRepaymentRunning": "Ausgewählte Transaktionen werden verarbeitet...",
    "aiLabelLoanRepaymentRunningTakesUpTo30s": "Dies kann bis zu 30 Sekunden dauern.",
    "run": "Ausführen",
    "separateInterestFromPrincipal": "Zinsen von Tilgung trennen",
    "splitLabelLoan": "Darlehen: teilen, verlinken + taggen.",
    "splitLabelLoanInfo": "Teile Darlehenrate in den Zins- und Tilgungsanteil auf, verlinke sie mit dem Darlehen-Projekt und tagge sie.",
    "splitLabelLoanInfo2": "Darlehenrate muss aufgeteilt werden, da beide Teile sich unterschiedlich auf das Kapitaleinkommen auswirken. Die Labels werden den neuen Transaktionen automatisch zugewiesen. Eine gelinkte Transaktion in dem Darlehen-Konto kann auch erstellt werden.",
    "calculateExpectedSplitInfo": "Falls es in der Transaktion keine Infos zu der Aufteilung von Zins/Kapital dieser Rate gibt, wir können sie anhand Darlehenparameter berechnen.",
    "delete": "Löschen",
    "pressSaveToDelete": "Drücke >Speichern<, um diese Transaktion zu löschen.",
    "pick": "Ein Projekt auswählen",
    "error": "Bitte überprüfe deine Eingabe.",
    "amountToAllocate": "Noch aufzuteilen",
    "allocatedTooMuch": "Zu viel aufgeteilt um",
    "amountToAllocateInterest": "Zinsen noch aufzuteilen",
    "allocatedTooMuchInterest": "Zu viel Zinsen aufgeteilt um",
    "selectLoanAccount": "Darlehen-Konto auswählen",
    "splitAndLabelLoanInfo": "Teile diese Kreditrate in Tilgung und Zinsen auf.",
    "splitAndLabelLoanInfo2": "Die Banktransaktion bleibt eine einzelne Kreditrate. Die Aufteilung in Tilgung und Zinsen wird fuer den Kreditverlauf und fuer KPI-Berechnungen verwendet.",
    "transactionDescriptionLabel": "Aktuelle Transaktionsbeschreibung",
    "transactionDescriptionEmpty": "Keine Beschreibung",
    "calculateExpectedSplit": "Erwartete Aufteilung berechnen"
  },
  "settings": {
    "symbol": "Symbol",
    "dividend": "Dividend (% pro Jahr)",
    "growthRate": "Wachstum (% pro Jahr)",
    "add": "Add",
    "simulatedAccountGrowth": {
      "heading": "Simuliertes Kontowachstum",
      "description": "Dieser Wert wird verwendet, um zukünftiges Wachstum all deiner Aktien-Konten zu simulieren. Weitere Informationen findest du in diesem Blog-Eintrag.",
      "fieldLabel": "Wachstumsrate",
      "dividendPayments": "Du kannst auch zukünftige Dividendenzahlungen simulieren - über alle Aktien-Konten hinweg. Gebe die erwartete Dividende pro Aktie pro Jahr an, die jährlich um die oben angegebene Wachstumsrate erhöht wird.",
      "dividendTooltip": "Dividende / Zins wird als % der aktuellen Wert berechnet."
    },
    "spread": {
      "description": "Wir berechnen den aktuellen Wert deiner Edelmetalle basierend auf dem realistischen Preis, den du beim Verkauf deines Vermögenswerts erzielen wirst.",
      "description2": "Dieser Preis ist niedriger als der Marktpreis aufgrund der Marge des Käufers (genannt 'Spread'). Wir empfehlen einen konservativen Spread von 10% des Marktpreises, aber du kannst ihn hier ändern. Der Spread wird vom aktuellen Marktwert deiner Metallwerte abgezogen.",
      "label": "Spread (%)",
      "error": "Bitte gib einen Spread-Prozentsatz an"
    },
    "autoImportPretransformation": {
      "heading": "Importeinstellungen merken",
      "body": "Beim nächsten Import für dieses Konto können wir deine früheren Import-Transformationen automatisch anwenden.",
      "label": "Importeinstellungen merken"
    },
    "realEstateValuations": {
      "heading": "Konten für automatische Bewertungs-Updates auswählen",
      "label": "Wir können Bewertungen für einige deiner Immobilienkonten automatisch aktualisieren. Wähle aus, welche das sein sollen."
    }
  },
  "loanIndicators": {
    "principalRemaining": "Restkapital",
    "interestRemaining": "Restzinsen",
    "history": "Verlauf",
    "loanRepaid": "Getilgtes Kapital",
    "loanRepaidTooltip": "Welcher Prozentsatz des Kapitals bis heute getilgt wurde.",
    "interest": "Zinsen",
    "interestPaid": "bis heute gezahlt",
    "interestTooltip": "Gesamtbetrag der bis heute gezahlten Zinsen und wie viel Prozent des bisher getilgten Kapitals das ist.",
    "interestPaidToPrincipalPaid": "vs. getilgtes Kapital",
    "balance": "Saldo",
    "balanceTooltip": "Verbleibender zu zahlender Betrag (Kapital + Zinsen), wenn das Darlehen gemäß Tilgungsplan zurückgezahlt wird."
  },
  "pensionIndicators": {
    "presentValueChanges": "Änderungen der erwarteten Auszahlungen",
    "roi": "Kapitalrendite",
    "sumContributions": "Beiträge",
    "sumContributionsTooltip": "Gesamtbetrag der bisher gezahlten Beiträge.",
    "presentValue": "Produktwert",
    "presentValueTooltip": "Wert Ihres Pensionsprodukts in heutigem Geld."
  },
  "unlistedShares": {
    "wizard": {
      "transactions": {
        "header": "Welche Art von Transaktion fügen wir hinzu?",
        "moreShares": "Neue Aktien kaufen",
        "moreCapital": "Eigenkapital erhöhen (ohne neue Aktien zu emittieren)",
        "sharesSale": "Aktien verkaufen",
        "capitalDisbursement": "Eigenkapital als Auszahlung erhalten (Kapitalausschüttung)",
        "error": "Bitte wähle eine Option",
        "formHeader": "Details der Transaktion",
        "submit": "Speichern",
        "deleteThisTransaction": "Löschen",
        "clickToOpenDeposit": "Um Eigenkapital ein- oder auszuzahlen, ohne Aktien zu emittieren / zurückzukaufen, gehe zum verbundenen Bankkonto und tagge deine Transaktion als 'Kapitalerhöhung' oder 'Kapitalauszahlung':",
        "noConnectedDeposit": "Verbinde zuerst ein Bankkonto (Button oben, direkt unter Firmenname).",
        "quantity": {
          "label": "Anzahl an Aktien",
          "tooltip": "Anzahl der Aktien, die du kaufst oder verkaufst",
          "error": "Bitte gib eine Anzahl an"
        },
        "upac": {
          "label": "Preis pro Stück",
          "tooltip": "Preis pro Aktie, in der Währung dieses Kontos",
          "error": "Bitte gib einen Preis an"
        },
        "capitalAmount": {
          "label": "Kapitalerhöhungsbetrag",
          "tooltip": "Betrag, den du in das Unternehmen investierst, in der Währung dieses Kontos",
          "error": "Bitte gib einen Betrag an"
        },
        "capitalDisbursementAmount": {
          "label": "Kapitalerauszahlungsbetrag",
          "tooltip": "Betrag, den du aus dem Eigenkapital des Unternehmen erhälst, in der Währung dieses Kontos",
          "error": "Bitte gib einen Betrag an"
        },
        "dateUserInput": {
          "label": "Datum",
          "tooltip": "Datum der Transaktion",
          "error": "Bitte gib ein Datum an"
        }
      },
      "valuation": {
        "title": "Firmenwert-Rechner",
        "description": "Wähle  die Lebenszyklusphase deines Unternehmens unten aus oder trage einen Wert manuell ein.",
        "score": {
          "-2": {
            "label": "Viel weniger",
            "tooltip": "Dein Unternehmen ist in einer deutlich schlechteren Position als der Markt / seine Mitbewerber"
          },
          "-1": {
            "label": "Weniger",
            "tooltip": "Dein Unternehmen ist in einer schlechteren Position als der Markt / seine Mitbewerber"
          },
          "0": {
            "label": "Neutral",
            "tooltip": "Dein Unternehmen ist in einer ähnlichen Position wie der Markt / seine Mitbewerber"
          },
          "1": {
            "label": "Mehr",
            "tooltip": "Dein Unternehmen ist in einer besseren Position als der Markt / seine Mitbewerber"
          },
          "2": {
            "label": "Viel mehr",
            "tooltip": "Dein Unternehmen ist in einer deutlich besseren Position als der Markt / seine Mitbewerber"
          }
        },
        "stage": {
          "label": "Stage",
          "tooltip": "Bewertungsmethoden, die wir anwenden können, hängen von der Entwicklungsphase deines Unternehmens ab. Wähle die Phase aus, die das Unternehmen momentan am besten beschreibt.",
          "idea": {
            "label": "Idee",
            "tooltip": "Das Unternehmen befindet sich in der Ideenphase. Es wurde noch nicht gegründet."
          },
          "prototype": {
            "label": "Prototyp",
            "tooltip": "Das Unternehmen hat einen Prototyp oder die Arbeit ist sehr fortgeschritten. Der Markteintritt ist noch nicht erfolgt."
          },
          "mvp": {
            "label": "MVP",
            "tooltip": "Das Unternehmen hat ein Minimum Viable Product und testet es auf dem Markt."
          },
          "expansion": {
            "label": "Expansion",
            "tooltip": "Das Unternehmen wächst schnell und hat eine stabile Kundenbasis."
          },
          "market": {
            "label": "Markt",
            "tooltip": "Das Unternehmen ist gut etabliert und hat eine starke Kundenbasis."
          }
        },
        "valuationMethod": {
          "label": "Verfügbare Bewertungsmethoden",
          "tooltip": "Wähle die Methoden aus, die du zur Bewertung deines Unternehmens verwenden möchtest. Du kannst mehrere Methoden auswählen."
        },
        "info": "Vergleiche dein Unternehmen mit ähnlichen Unternehmen auf dem Markt. Die Bewertungsmethoden werden basierend auf den von dir bereitgestellten Informationen angewendet.",
        "insufficientData": "Mehr Daten erforderlich",
        "insufficientDataTooltip": "Wir brauchen noch die folgenden Infos, um die Schätzung zu berechnen: {{fields}}.",
        "required": "Bitte gib sowohl das Datum als auch die Bewertung an.",
        "ideaStrength": {
          "label": "Stärke der Idee",
          "tooltip": "Die Stärke der Idee oder des Geschäftskonzepts hinter dem Unternehmen"
        },
        "prototypeProgress": {
          "label": "Prototyp Fortschritt",
          "tooltip": "Der Fortschritt bei der Entwicklung des Produktprototyps ('viel weniger', wenn kein Prototyp existiert, 'viel mehr', wenn ein vollständig getesteter Prototyp existiert)"
        },
        "teamCapability": {
          "label": "Teamfähigkeit",
          "tooltip": "Die Fähigkeit und Erfahrung der Teammitglieder"
        },
        "marketingRelationships": {
          "label": "Marketingbeziehungen",
          "tooltip": "Die Stärke und das Ausmaß der Marketing- / Lieferkettenbeziehungen"
        },
        "marketTraction": {
          "label": "Markttraktion",
          "tooltip": "Erfolg bei der Einführung des Produkts auf dem Markt / Umsatzwachstum"
        },
        "competitiveAdvantage": {
          "label": "Wettbewerbsvorteil",
          "tooltip": "Hat dieses Unternehmen irgendeine Art von Vorteil gegenüber seinen Wettbewerbern?"
        },
        "similarStartupValuationsArray": {
          "label": "Bewertungen ähnlicher Unternehmen",
          "tooltip": "Ungefähre Bewertungen für ähnliche Unternehmen"
        },
        "technologyRisk": {
          "label": "Technologisches Vertrauen",
          "tooltip": "Im Vergleich zu ähnlichen Unternehmen, ist die von diesem Unternehmen verwendete Technologie mehr oder weniger riskant?"
        },
        "ipStrength": {
          "label": "Stärke des geistigen Eigentums",
          "tooltip": "Besitzt das Unternehmen alle wichtigen Patente / geistiges Eigentum, die für den Start und das weitere Wachstum notwendig sind?"
        },
        "totalAdressableMarketSize": {
          "label": "Gesamte adressierbare Marktgröße",
          "tooltip": "Die Gesamtgröße des Marktes, den das Unternehmen adressieren kann"
        },
        "marketGrowthRate": {
          "label": "Marktwachstumsrate",
          "tooltip": "Die Wachstumsrate des Marktes, in dem das Unternehmen tätig ist"
        },
        "marketEntryBarriers": {
          "label": "Markteintrittsbarrieren",
          "tooltip": "Wie schwierig (wegen Kapital, Werkzeuge, geistiges Eigentum etc.) ist es, ein Unternehmen in diesem Markt zu gründen?"
        },
        "needForMoreInvestment": {
          "label": "Bedarf an weiteren Investitionen",
          "tooltip": "Wie viel mehr Investitionen sind erforderlich, um das Unternehmen auf die nächste Stufe zu bringen?"
        },
        "legalRisk": {
          "label": "Rechtliche Stabilität",
          "tooltip": "Je mehr rechtliche (Gesetzgebung, Patente etc.) Risiken das Unternehmen haben könnte, desto geringer ist die Stabilität."
        },
        "internationalRisk": {
          "label": "Internationale Stabilität",
          "tooltip": "Die Risiken im Zusammenhang mit der Ausweitung der internationalen Geschäftstätigkeit"
        },
        "marketRisk": {
          "label": "Marktstabilität",
          "tooltip": "Ist der Markt, in dem das Unternehmen tätig ist, stabil ('mehr') oder volatil ('weniger')?"
        },
        "financialPerformance": {
          "label": "Finanzielle Leistung",
          "tooltip": "Die finanzielle Leistung des Unternehmens (Rentabilität)"
        },
        "assetsArray": {
          "label": "Vermögenswerte",
          "tooltip": "Eine Auflistung der Vermögenswerte des Unternehmens"
        },
        "intangiblesArray": {
          "label": "Immaterielle Werte",
          "tooltip": "Eine Auflistung der immateriellen Werte des Unternehmens"
        },
        "liabilitiesArray": {
          "label": "Verbindlichkeiten",
          "tooltip": "Eine Auflistung der Verbindlichkeiten des Unternehmens"
        },
        "targetRaisedCapital": {
          "label": "Kapital zu beschaffen",
          "tooltip": "Welches Kapital möchte dein Unternehmen derzeit beschaffen?"
        },
        "cashFlowArray": {
          "label": "Cashflows",
          "namePlaceholder": "Jahr",
          "tooltip": "Wie sehen die erwarteten Cashflows deines Unternehmens aus?"
        },
        "discountRate": {
          "label": "Abzinsungssatz (in %)",
          "tooltip": "Der Abzinsungssatz, der in der DCF-Methode verwendet wird (Kapitalbeschaffungskosten für dein Unternehmen, d.h. ungefähr welcher Zinssatz wird auf Darlehen gezahlt)"
        },
        "longTermGrowthRate": {
          "label": "Stabile Wachstumsrate (in %)",
          "tooltip": "Langfristige, nachhaltige Wachstumsrate, sobald die Cashflows stabil sind (sollte konservativ sein und niedriger als der Abzinsungssatz). Wird zur Berechnung des Terminalwerts verwendet.",
          "error": "Die stabile Wachstumsrate muss für diese Berechnung niedriger als der Abzinsungssatz sein."
        },
        "finalQuote": {
          "label": "Endbewertung",
          "tooltip": "Welche Bewertung möchtest du speichern, basierend auf den bereitgestellten Informationen?",
          "error": "Bitte gebe eine Endbewertung an",
          "description": "Bestimme die endgültige Bewertung des Unternehmens basierend auf den bereitgestellten Informationen.",
          "save": "Speichern",
          "deleteThisQuote": "Diese Bewertung löschen",
          "resetThisQuote": "Bewertung zurücksetzen"
        },
        "percentOwned": {
          "label": "Anteil in Besitz",
          "tooltip": "Welchen Anteil dieses Unternehmen besitzt du?",
          "error": "Bitte gebe den Anteil an, den du besitzt"
        },
        "methods": {
          "berkus": {
            "label": "Berkus",
            "tooltip": "Eine Methode zur Bewertung von Startups basierend auf Idee, Prototyp, Team, Markttraktion und Wettbewerbsvorteil."
          },
          "scorecard": {
            "label": "Scorecard",
            "tooltip": "Eine Methode zur Bewertung von Startups mittels eines Punktesystems, das verschiedene Aspekte wie Team, Produkt und Markt vergleicht."
          },
          "riskFactor": {
            "label": "Risikofaktor",
            "tooltip": "Eine Methode zur Bewertung der Risiken eines Startups, einschließlich Technologie-, Markt- und Teamrisiken."
          },
          "valuationByStage": {
            "label": "Bewertung nach Phase",
            "tooltip": "Eine Methode zur Bestimmung des Werts eines Startups basierend auf seiner aktuellen Entwicklungsphase."
          },
          "replacementCost": {
            "label": "Ersatzkosten",
            "tooltip": "Eine Methode zur Berechnung der Kosten, um die Vermögenswerte und den Betrieb des Unternehmens zu ersetzen."
          },
          "bookValue": {
            "label": "Buchwert",
            "tooltip": "Eine Methode zur Bewertung des Nettovermögens eines Unternehmens durch Abzug der Verbindlichkeiten von den Vermögenswerten."
          },
          "fiveTimesYourRise": {
            "label": "Fünfmal dein Kapital",
            "tooltip": "Eine Methode, bei der das Zielkapital um das Fünffache multipliziert wird, um den Unternehmenswert zu schätzen."
          },
          "dcf": {
            "label": "DCF",
            "tooltip": "Eine Discounted Cash Flow-Methode zur Bewertung eines Unternehmens basierend auf seinen prognostizierten zukünftigen Cashflows."
          }
        }
      }
    }
  },
  "cryptoAssetMappingDialog": {
    "header": "Automatische Preisaktualisierungen",
    "prompt": "Kryptowährungen sind dezentralisiert. Um sicherzustellen, dass wir den richtigen Preis für deine Vermögenswerte ermittelt haben, überprüfe diese Zuordnungen und klicke auf >Speichern<. Wenn die vorgeschlagenen Preise zu deinem Asset nicht passen, lasse es unmarkiert.",
    "asset": "Krypto-Symbol",
    "status": "Preise ermittelt",
    "headerAssetDetails": "Preise finden für:",
    "promptAssetDetails": "Für diese Kryptowährungen können wir die Preise automatisch aktualisieren. Wähle eine aus oder suche nach einem passenden Begriff, danach klicke auf >OK<. Wenn keine der vorgeschlagenen Kryptowährungen passt, lasse die Liste unmarkiert.",
    "symbol": "Symbol",
    "name": "Name",
    "marketCap": "Marktgröße",
    "liquidity": "Liquidität",
    "price": "Aktueller Preis",
    "page": "Seite",
    "pageOf": "von",
    "next": "Nächstes",
    "previous": "Voheriges",
    "noResults": "Keine Preise gefunden"
  },
  "filterDialog": {
    "filter": "Filter",
    "prompt": "Wähle nur Zellen aus, die folgende Bedingungen erfüllen:",
    "is": "ist",
    "isNot": "ist nicht",
    "contains": "enthält",
    "doesNotContain": "enthält nicht",
    "startsWith": "beginnt mit",
    "doesNotStartWith": "beginnt nicht mit",
    "endsWith": "endet mit",
    "doesNotEndWith": "endet nicht mit",
    "greaterThan": "größer als",
    "greaterThanOrEqual": "größer als oder gleich",
    "lessThan": "kleiner als",
    "lessThanOrEqual": "kleiner als oder gleich",
    "equalTo": "gleich",
    "blank": "leer",
    "phrase": "Ausdruck",
    "addMore": "Weitere hinzufügen",
    "cancel": "Abbrechen",
    "rulesErrorLength": "Der Wert darf maximal 200 Zeichen lang sein.",
    "rulesErrorNumber": "Der Wert muss eine Zahl sein."
  },
  "tableFilters": {
    "results": "{{shown}} von {{total}} Zeilen",
    "clearAll": "Filter löschen"
  },
  "tableFiltersDialog": {
    "title": "Liste filtern",
    "description": "Verfeinere die sichtbaren Zeilen, ohne Daten zu verändern.",
    "searchLabel": "Suchbegriff",
    "searchPlaceholder": "Beschreibung, Gegenpartei, IBAN...",
    "amountLabel": "Betrag",
    "amountAny": "Beliebiger Betrag",
    "amountInflow": "Nur Zuflüsse",
    "amountOutflow": "Nur Abflüsse",
    "amountZero": "Betrag = 0",
    "dateLabel": "Datum",
    "dateAll": "Alle Daten",
    "date30d": "Letzte 30 Tage",
    "date90d": "Letzte 90 Tage",
    "date365d": "Letzte 12 Monate",
    "reset": "Zurücksetzen",
    "cancel": "Abbrechen",
    "apply": "Filter anwenden"
  },
  "gettingStarted": {
    "heading": "Erste Schritte",
    "subheading": "Fülle dein neues Konto mit Daten",
    "intro": "Es ist einfach anzufangen, und du entscheidest, wie du das tun möchtest.\nErinnere dich: Alles, was du tust, kann später aktualisiert werden.",
    "features": [
      {
        "name": "Gib das aktuelle Saldo ein",
        "description": "Klicke auf >Bearbeiten<, gib das aktuelle Kontosaldo ein und speichere. Du kannst später mehr Details hinzufügen."
      },
      {
        "name": "Transaktionen aus Datei importieren",
        "description": "Lade eine Transaktionsdatei aus dem Online-Banking deiner Bank herunter. Sobald du sie hast, drücke den >Importieren<-Button und folge unseren Schritt-für-Schritt-Anweisungen."
      },
      {
        "name": "Transaktionen automatisch abrufen",
        "description": "Wenn es eine technische Verbindung gibt, kannst du deine Transaktionen automatisch abrufen. Drücke einfach auf den >Sync<-Button und wir erledigen den Rest."
      }
    ],
    "cashflow": {
      "heading": "Warum sind hier keine Daten?",
      "subheading": "Tagge die zugehörigen Auszahlungen und Kosten im Verrechnungskonto",
      "intro": "Erfasse die Transaktionen im verbundenen Verrechnungskonto und tagge sie für dieses Konto, damit sie hier erscheinen.",
      "navigateIntro": "Öffne jetzt das verknüpfte Verrechnungskonto, um die Transaktionen für dieses Asset zu taggen:"
    },
    "values": {
      "heading": "Eigene Werte",
      "subheading": "Pflege deinen Preisverlauf",
      "intro": "Hinterlege eigene Preise, wenn Marktdaten fehlen oder überschrieben werden sollen.",
      "features": [
        {
          "name": "Preise im Grid bearbeiten",
          "description": "Klicke auf Bearbeiten, wechsle in den Grid-Modus und trage deine Preise pro Asset ein, dann speichern."
        },
        {
          "name": "Bewertungen importieren",
          "description": "Nutze Import, um Preisdaten hochzuladen statt sie abzutippen."
        }
      ]
    }
  }
}
